import React from 'react';
export default class CustomLoaderWithText extends React.Component {
    render() {
        const {isFrom}=this.props
        return (
            <div className="loader-back" style={{
                display:'flex',
                flexDirection:'column'
            }}>
                <div class="lds-roller" style={{margin:"20px"}}><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
                <div style={{
                    fontSize:"16",
                    fontWeight:"800",
                    color: "white"
                }}>Please Wait. Upload In Progress...</div>
            </div>
        );
    }
}